import { Routes, Route } from 'react-router-dom'
import { Header } from './components/Header'
import Home from './pages/Home'
import Players from './pages/Players'
import About from './pages/About'
import NotFound from './pages/NotFound'

function App() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/players" element={<Players />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  )
}

export default App
